/* eslint-disable default-case */
import React from 'react';
// eslint-disable-next-line import/no-cycle
import ModalChild from './modal';
export var ModalByTextTestIds;
(function (ModalByTextTestIds) {
    ModalByTextTestIds["ModalByTextlinkId"] = "cmsModalByTextlink__testid";
})(ModalByTextTestIds || (ModalByTextTestIds = {}));
var ModalByTextlink = function (_a, componentKey) {
    var contentData = _a.contentData;
    if (componentKey === void 0) { componentKey = ''; }
    var content = contentData.field_content, paragraph = contentData.paragraph;
    var modalChild = content;
    paragraph.forEach(function (modal) {
        modalChild = ModalChild(modalChild, modal);
        return modalChild;
    });
    return (React.createElement("div", { "data-testid": "" + ModalByTextTestIds.ModalByTextlinkId, key: componentKey }, modalChild));
};
export default ModalByTextlink;
//# sourceMappingURL=index.js.map